module.exports = __webpack_public_path__ + "media/vonix_ring1.0caca116.wav";